import { useMsal } from '@azure/msal-react'
import Cookies from 'js-cookie'

const Logout = () => {
	const {instance} = useMsal() 

	localStorage.clear()
	Cookies.remove('msal.cache.encryption', {path: '/'})
	Cookies.remove('HealUserId', {path: '/api/empd_query_builder/query'})
	Cookies.remove('HealUserId', {path: '/api/empd/microsoft_ad'})
	instance.logoutRedirect({
		account: instance.getActiveAccount(),
        postLogoutRedirectUri: "/",
    })
	return null
}

export default Logout
